import axios from 'axios';

export default {
    async changePassword(dataParams) {
        return axios.post(`api/account/change-password`, dataParams);
    }
};
